module.exports = __webpack_public_path__ + "img/more-icon.0ea3448f.svg";